import { render, staticRenderFns } from "./DashboardCompanyUsers.vue?vue&type=template&id=37f59df7&scoped=true&"
import script from "./DashboardCompanyUsers.vue?vue&type=script&lang=js&"
export * from "./DashboardCompanyUsers.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCompanyUsers.vue?vue&type=style&index=0&id=37f59df7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f59df7",
  null
  
)

export default component.exports